<footer id="footer">
  <!-- Premère ligne -->
  <div class="flex-container">
    <!-- Logos -->
    <div class="logo">
        <img [src]="getImageUrl('logo_pronatura.png')" alt="logo PN" class="logoPN">

        <img [src]="getImageUrl('logo_vitafrais.svg')" alt="logo VTF" class="logoVTF">

        <img [src]="getImageUrl('logo_organic_alliance.svg')" alt="logo OA" class="logoOA">

        <img [src]="getImageUrl('AB.svg')" alt="logo AB" class="logoAB">

         <img [src]="getImageUrl('logo_eurofeuille.png')" alt="logo AB" class="logoAB">
    </div>

    <!-- Liens vers les sites du groupe -->
    <div>
      <a class="btn btn-rounded btn-footer-vtf mx-2 hide-lg" href="https://www.vitafrais.fr/" target="_blank">
        <span class="dashboard-text">vitafrais.fr</span>
      </a>

      <a class="btn btn-rounded btn-footer-pn mx-2 hide-lg" href="https://www.pronatura.com/" target="_blank">
        <span class="dashboard-text">pronatura.com</span>
      </a>

      <a class="btn btn-rounded btn-footer-oa mx-2 hide-xl" href="https://www.organic-alliance.com/" target="_blank">
        <span class="dashboard-text">organic-alliance.com</span>
      </a>
    </div>

    <!-- Liens vers les réseaux -->
    <div class="reseau">
      <span>Suivez-nous : &nbsp;</span>
      <a href="https://www.linkedin.com/company/organic-alliance/" target="_blank">
        <img [src]="getImageUrl('logo_linkedin.png')" alt="logo LinkedIn">
      </a>
    </div>
  </div>

  <!-- Liens vers les différentes section -->
  <!-- <div class="planSite">
      <a class="dashboard-link" [routerLink]="['/user', 'details']">
        <span class="dashboard-text">{{ 'dashboard.customerInformations' | translate }}</span>
      </a>
      <div class="text-highlight text-bold">&nbsp; | &nbsp;</div>
      <a class="dashboard-link" [routerLink]="['/online-payment']">
        <span class="dashboard-text">{{ 'online-payment.title' | translate }}</span>
      </a>
      <div class="text-highlight text-bold">&nbsp; | &nbsp;</div>
      <a class="dashboard-link" [routerLink]="['/online-payment','account-book']">
        <span class="dashboard-text">{{ 'accountBook.title' | translate }}</span>
      </a>
      <div class="text-highlight text-bold">&nbsp; | &nbsp;</div>
      <a class="dashboard-link" [routerLink]="['/dashboard', 'orders']">
        <span class="dashboard-text">{{ 'dashboard.ordersHistory' | translate }}</span>
      </a>
      <div class="text-highlight text-bold">&nbsp; | &nbsp;</div>
      <a class="dashboard-link" [routerLink]="['/dashboard', 'invoices']">
        <span class="dashboard-text">{{ 'dashboard.invoicesHistory' | translate }}</span>
      </a>
      <div class="text-highlight text-bold">&nbsp; | &nbsp;</div>
      <a class="dashboard-link" [routerLink]="['/dashboard', 'delivery-notes']">
        <span class="dashboard-text">{{ 'dashboard.deliveryFrequenciesHistory' | translate }}</span>
      </a>
      <div class="text-highlight text-bold">&nbsp; | &nbsp;</div>
      <a class="dashboard-link" [routerLink]="['/dashboard', 'claims']">
        <span class="dashboard-text">{{ 'dashboard.claimsHistory' | translate }}</span>
      </a>
      <div *ngIf="isVitafrais()"  class="text-highlight text-bold">&nbsp; | &nbsp;</div>
      <a *ngIf="isVitafrais()" class="dashboard-link" [routerLink]="['/user', 'reclamation']">
        <span class="dashboard-text">{{ 'dashboard.doclaims' | translate }}</span>
      </a>
      <div class="text-highlight text-bold">&nbsp; | &nbsp;</div>
      <a class="dashboard-link" [routerLink]="['/dashboard', 'terms-of-service']">
        <span class="dashboard-text">{{ 'dashboard.termsOfService' | translate }}</span>
      </a>
  </div> -->

  <!-- Mentions légales -->
  <div class='view-container'>
    <div class='container'>
      <div class='columns'>
        <div class='column col-12 col-lg-12 col-sm-12' style="text-align: center">
          © Organic Alliance - Tous droits réservés - <u><a href='http://www.organic-alliance.com/content/mentions-légales/' target="_blank">Mentions Légales</a></u>
        </div>
      </div>
    </div>
  </div>
</footer>
